export default "__VITE_ASSET__Brel3Vxv__"